import { Component, Inject, inject, ChangeDetectionStrategy } from '@angular/core';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SpinnerComponent } from '@custom-components/general/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserStore } from '@root/app/store/user.store';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

@Component({
  selector: 'resend-invite-dialog',
  imports: [
    MatIconModule,
    MatDialogModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    TranslateModule,
    SpinnerComponent,
    DialogShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './resend-invite-dialog.component.html',
})
export class ResendInviteDialogComponent {
  readonly userStore = inject(UserStore);
  readonly dialogRef = inject(MatDialogRef<ResendInviteDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  userOid: string;
  isResendingInvite = false;
  resendInviteSuccess = false;
  resendInviteError = false;

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.userOid = data.userOid;
  }

  onResend() {
    this.isResendingInvite = true;
    let resendObservable = this.userStore.resendInvite(this.userOid);
    resendObservable.subscribe({
      next: () => {
        this.isResendingInvite = false;
        this.resendInviteSuccess = true;
      },
      error: () => {
        this.isResendingInvite = false;
        this.resendInviteError = true;
      },
    });
  }
}
